export default __webpack_public_path__ + "static/media/partner-16.2121eb69.png";